interface Validation {
  check(): boolean;
}

interface Remove {
  remove(): string;
}

export class SpaceValidator implements Validation, Remove {
  private _text = '';
  private readonly _regex = /%E2%80%8B|[\s\u200B-\u200D\uFEFF]/g; // for space and zero width space
  constructor(text: string) {
    this._text = text;
  }

  check(): boolean {
    return this._regex.test(this._text);
  }

  remove(): string {
    return this._text.replace(this._regex, '');
  }
}
